import  ApolloClient   from 'apollo-boost';
import { Environment } from "../enviroment";

const  GRAPHQL_URL  = Environment.GRAPHQL_URL;

export  const apolloClient = new ApolloClient({
    uri: GRAPHQL_URL
});